import React, { useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-regular-svg-icons";
import { ClavaContext } from "../../../config/contexts";
import ClavaButton from "../ClavaButton";
import { translate } from "../../../config/translator";
import Overlay from "../Overlay";

const modalRoot = document.getElementById("app") as HTMLElement;
const loadingGif = require("../../../assets/images/loading.gif");

const AsideModal: React.FC<React.PropsWithChildren<{
  close: () => void,
  saveClb?: () => void,
  saveText?: string,
  saveDisabled?: boolean,
  loading?: boolean,
  title: string
}>> = ({ close, title, saveDisabled, children, saveClb, loading, saveText }) => {
  const { l } = useContext(ClavaContext);
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return ReactDOM.createPortal(
    <>
      <Overlay close={close} />
      <div
        className="fixed right-0 top-24 h-[calc(100vh-6rem)] text-font dark:text-font-dark rounded-l-xl min-w-96 bg-bg-secondary dark:bg-bg-secondary-dark flex flex-col items-stretch justify-start">
        <div
          className="flex flex-row items-center  justify-between px-4 pt-4 pb-2 border-b border-b-light-gray dark:border-b-light-gray-dark">
          <h3 className="font-semibold text-base ">{title}</h3>
          <button type="button" className="border-none bg-none outline-0 p-2" onClick={close}>
            <FontAwesomeIcon icon={faClose} size="lg" />
          </button>
        </div>
        <div
          className="px-4 py-2 overflow-y-scroll flex-1 flex flex-col items-stretch justify-start">
          {children}
        </div>
        {!!saveClb && (
          <div className="px-4 py-2 flex items-center justify-center">
            <ClavaButton onClick={saveClb} disabled={saveDisabled}>
              {loading ? (<img src={loadingGif} alt="Loading"
                               className="w-4 h-4" />) : saveText ?? translate("save", l)}
            </ClavaButton>
          </div>
        )}
      </div>
    </>, modalRoot
  );
};

export default AsideModal;
